(function($) {
  $(document).on('click', 'a[href]', function(event) {
    if ($(this).is('[data-toggle]')) return;

    var offset = 0;
    var hash = event.currentTarget.hash;
    if (hash && $(hash).length) {
      event.preventDefault();
      offset += ($('body').hasClass('admin-bar') && $('#wpadminbar').css('position') === 'fixed') ? $('#wpadminbar').height() : '0';
      offset += ($('.site-header').length && $('.site-header').css('position') === 'fixed') ? $('.main-header').height() : '0';
      window.scroll({
        behavior: 'smooth',
        top: $(hash).offset().top - offset
      })
    }
  });
})(jQuery);